import styled from 'styled-components'

export const SortableItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  background-color: ${props => (props.index % 2 === 0 ? props.theme.colors.background.secondary : 'transparent')};
  border-radius: ${props => props.theme.primitives.radius.radius2};

  #draggable-icon {
    cursor: ${props => (props.isSortable ? 'grab' : 'default')};
  }

  & > :last-child {
    flex-grow: 1;
  }
`
